import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from '../components/paymentForm';
import axios from 'axios';

export default function Payment() {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const fetchStripeKey = async () => {
      const tokenFromStorage = localStorage.getItem("token");
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/payments/stripe_config`, {
          headers: {
            Authorization: `Bearer ${tokenFromStorage}`
          }
        });
        const key = res.data?.publishableKey;
        if (key) {
          setStripePromise(loadStripe(key));
        }
      } catch (err) {
        console.error('Failed to fetch Stripe key:', err);
      }
    };

    fetchStripeKey();
  }, []);

  return (
    <div className="bg-[#191919] p-0 p-md-5 flex flex-col items-center justify-center h-full">
      {stripePromise && (
        <Elements stripe={stripePromise}>
          <PaymentForm />
        </Elements>
      )}
    </div>
  );
}
